import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const Capsule = styled.span`
  align-items: center;
  background: ${colors.greenDark};
  box-sizing: content-box;
  border-radius: 100vh;
  color: ${colors.white};
  display: inline-flex;
  justify-content: center;
  font-size: 0.75rem;
  margin: 0;
  min-height: 1.0625rem;
  min-width: 1.0625rem;
  outline: 0;
  padding: 1px;
  position: relative;
  user-select: none;
`;
